import { Platform } from '../types/Campaign';

const DspUtils = {
    getOrderUrl: (
        dspEntityId: string,
        dspCampaignId: string,
        platform: Platform,
        dv360AdvertiserId?: string
    ): string => {
        if (platform === Platform.AMAZON) {
            return `https://advertising.amazon.com/dsp/ENTITY${dspEntityId?.substring(1)}/orders/${dspCampaignId}/edit`;
        }
        if (platform === Platform.DV360) {
            return `https://displayvideo.google.com/ng_nav/p/${dspEntityId}/a/${dv360AdvertiserId}/c/${dspCampaignId}/explorer`;
        }
        return '';
    },
};

export default DspUtils;
